import { createFileRoute } from "@tanstack/react-router";

import { FleetsListPage } from "./-components/FleetsListPage";

export const Route = createFileRoute("/_staff/fleets/_layout/_list/")({
  component: FleetsListPage,
});
